import { ConciergeServicePageView } from '@/lib/pages/concierge';
import { getConciergePageStaticProps } from '@/lib/pages/concierge/get-static-props';

import { getConciergeSingaporeVisaPage } from '@/lib/entities/concierge/server-content';
import { SeoEntries } from '@/lib/entities/seo/lib/seo-entries';

import { InferGetStaticPropsType } from 'next';

const PATH = '/concierge/singapore-visa';

export default function SingaporeVisaPage({
  page,
  locale,
  pageSeo,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <>
      <SeoEntries
        fallback={{
          title: page.metaTitle,
          description: page.metaDescription,
          keywords: 'singapore visa concierge',
          openGraphImage: '/images/og.png',
        }}
        seo={pageSeo}
        language={locale}
        path={PATH}
      />
      <ConciergeServicePageView page={page} locale={locale} h1={pageSeo?.h1} />
    </>
  );
}

export const getStaticProps = getConciergePageStaticProps(
  getConciergeSingaporeVisaPage,
  PATH
);
